import React from "react";
import { shallowEqual, useSelector } from "react-redux";
import { makeStyles, useMediaQuery } from "@material-ui/core";
import { RootState } from "redux/rootReducer";
import { AuthenticationInfo } from "types/AuthenticationInfo";
import Aktia from "./BankLogos/Aktia";
import Alands from "./BankLogos/Alands";
import Danske from "./BankLogos/Danske";
import Handelsbanken from "./BankLogos/Handelsbanken";
import Nordea from "./BankLogos/Nordea";
import OmaSP from "./BankLogos/OmaSP";
import OP from "./BankLogos/OP";
import POP from "./BankLogos/POP";
import SaastoPankki from "./BankLogos/SaastoPankki";
import SPankki from "./BankLogos/SPankki";
import ChartLoader from "./ChartLoader";
import BackIcon from "./BackIcon";

const useStyles = makeStyles({
  container: {
    display: "flex",
    justifyContent: "center",
    overflowX: "hidden",
  },
  cardContainer: {
    backgroundColor: "#FFFFFF",
    border: "1px solid #DCDCDC",
    boxSizing: "border-box",
    margin: "25px 0",
    display: "inline-grid",
    width: "100%",
    overflowX: "hidden",
  },
  card: {
    padding: "0 20px",
    height: 84,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
  },
});

const correctBank = (authenticationInfo: AuthenticationInfo) => {
  switch (authenticationInfo.Id) {
    case "oidc.aktia.1":
      return <Aktia />;
    case "oidc.alandsbanken.1":
      return <Alands />;
    case "oidc.danskebank.1":
      return <Danske />;
    case "oidc.handelsbanken.1":
      return <Handelsbanken />;
    case "oidc.nordea.1":
      return <Nordea />;
    case "oidc.omasp.1":
      return <OmaSP />;
    case "saml.op.fi":
    case "saml.op.1":
      return <OP />;
    case "oidc.pop.1":
      return <POP />;
    case "oidc.sp.1":
      return <SaastoPankki />;
    case "oidc.spankki.1":
      return <SPankki />;
    default:
      return <></>;
  }
};

const BankList = () => {
  const authenticationInfo = useSelector(
    (state: RootState) => state.authenticationInfo.data,
    shallowEqual
  );

  const authenticationInfoLoading = useSelector(
    (state: RootState) => state.authenticationInfo.loading
  );

  const matchesMediaQuery = useMediaQuery("(min-width: 600px)");
  const matchesMediaQueryHeight = useMediaQuery("(min-height: 730px)");

  const classes = useStyles();

  const mobileHeight = authenticationInfoLoading
    ? "calc(100vh - 230px)"
    : matchesMediaQueryHeight
    ? "calc(100vh - 230px)"
    : "auto";

  return (
    <div
      className={classes.container}
      style={{
        alignItems: "center",
        height: matchesMediaQuery ? "calc(100% - 270px)" : mobileHeight,
      }}
    >
      <div
        style={{
          width: "fit-content",
          height: "fit-content",
          maxWidth: 750,
          textAlign: "center",
          margin: 16,
        }}
      >
        {authenticationInfoLoading ? (
          <div style={{ padding: "36px 0 20px 0" }}>
            <ChartLoader loginPage />
          </div>
        ) : (
          <>
            <div
              className={classes.cardContainer}
              style={{
                gridTemplateColumns: matchesMediaQuery
                  ? "1fr 1fr 1fr 1fr"
                  : "1fr 1fr",
                height: matchesMediaQuery ? "auto" : 300,
              }}
            >
              {authenticationInfo?.map((a, i) => (
                <div
                  key={a.Id}
                  onClick={() => {
                    window.location.assign(a.Url);
                  }}
                  className={classes.card}
                  style={{
                    borderRight:
                      (i + 1) % 4 === 0 ? undefined : "1px solid #DCDCDC",
                    borderBottom: i + 1 > 8 ? undefined : "1px solid #DCDCDC",
                  }}
                >
                  {correctBank(a)}
                </div>
              ))}
            </div>
          </>
        )}
        <button
          onClick={() => {
            window.location.replace("https://www.forea.fi");
          }}
          style={{
            fontSize: "1.125em",
            background: "transparent",
            border: "none",
            textTransform: "uppercase",
            color: "#ffffff",
            cursor: "pointer",
            outline: "none",
            letterSpacing: "0.09375em",
            marginTop: 16,
          }}
        >
          <BackIcon />
          Back
        </button>
      </div>
    </div>
  );
};

export default React.memo(BankList);
